import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "redemptions-content" }
const _hoisted_2 = {
  key: 0,
  class: "d-flex justify-center align-center py-4"
}
const _hoisted_3 = { key: 2 }
const _hoisted_4 = {
  key: 1,
  class: "text-center pa-4"
}

import { ref, onMounted } from 'vue'
import MainLayout from './components/MainLayout.vue'

interface Redemption {
  id: string
  itemName: string
  points: number
  timestamp: number
  claimed: boolean
  claimedAt?: number
}


export default /*@__PURE__*/_defineComponent({
  __name: 'MyRedemptions',
  setup(__props) {

const redemptions = ref<Redemption[]>([])
const loading = ref(true)
const error = ref('')

async function fetchRedemptions() {
  loading.value = true
  error.value = ''
  
  try {
    console.log('Fetching redemptions...')
    console.log('API URL:', `${process.env.VUE_APP_API_BASE_URL}/my-redemptions`)
    
    const response = await fetch(`${process.env.VUE_APP_API_BASE_URL}/my-redemptions`, {
      credentials: 'include',
      headers: {
        'Accept': 'application/json',
      }
    })
    
    console.log('Response status:', response.status)
    console.log('Response headers:', Object.fromEntries(response.headers.entries()))
    
    if (!response.ok) {
      const errorText = await response.text()
      console.error('Error response:', errorText)
      throw new Error(`Failed to fetch redemptions: ${response.status} ${response.statusText}`)
    }
    
    const data = await response.json()
    console.log('Redemptions data:', data)
    
    if (!Array.isArray(data)) {
      console.error('Unexpected data format:', data)
      throw new Error('Received invalid data format from server')
    }
    
    redemptions.value = data
  } catch (e) {
    console.error('Error details:', e)
    error.value = `Failed to load redemptions: ${e.message}`
  } finally {
    loading.value = false
  }
}

onMounted(() => {
  console.log('Component mounted, fetching redemptions...')
  fetchRedemptions()
})

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(MainLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_v_card, { elevation: "2" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "d-flex align-center" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, {
                  icon: "mdi-history",
                  class: "mr-2"
                }),
                _cache[0] || (_cache[0] = _createTextVNode(" My Redemptions ", -1))
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                (loading.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                      _createVNode(_component_v_progress_circular, {
                        indeterminate: "",
                        color: "primary"
                      })
                    ]))
                  : (error.value)
                    ? (_openBlock(), _createBlock(_component_v_alert, {
                        key: 1,
                        type: "error",
                        class: "my-4"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(error.value), 1)
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        (redemptions.value.length > 0)
                          ? (_openBlock(), _createBlock(_component_v_table, { key: 0 }, {
                              default: _withCtx(() => [
                                _cache[2] || (_cache[2] = _createElementVNode("thead", null, [
                                  _createElementVNode("tr", null, [
                                    _createElementVNode("th", null, "Item"),
                                    _createElementVNode("th", null, "Points"),
                                    _createElementVNode("th", null, "Date"),
                                    _createElementVNode("th", null, "Status")
                                  ])
                                ], -1)),
                                _createElementVNode("tbody", null, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(redemptions.value, (redemption) => {
                                    return (_openBlock(), _createElementBlock("tr", {
                                      key: redemption.id
                                    }, [
                                      _createElementVNode("td", null, _toDisplayString(redemption.itemName), 1),
                                      _createElementVNode("td", null, [
                                        _createVNode(_component_v_chip, {
                                          color: "primary",
                                          variant: "flat",
                                          size: "small",
                                          class: "font-weight-medium"
                                        }, {
                                          prepend: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                                            _createElementVNode("span", { class: "mr-1" }, "🙏", -1)
                                          ]))]),
                                          default: _withCtx(() => [
                                            _createTextVNode(" " + _toDisplayString(redemption.points), 1)
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _createElementVNode("td", null, _toDisplayString(new Date(redemption.timestamp).toLocaleString()), 1),
                                      _createElementVNode("td", null, [
                                        _createVNode(_component_v_chip, {
                                          color: redemption.claimed ? 'success' : 'warning',
                                          variant: "flat",
                                          size: "small",
                                          class: "font-weight-medium"
                                        }, {
                                          prepend: _withCtx(() => [
                                            _createVNode(_component_v_icon, {
                                              icon: redemption.claimed ? 'mdi-check-circle' : 'mdi-clock',
                                              size: "16",
                                              color: "white"
                                            }, null, 8, ["icon"])
                                          ]),
                                          default: _withCtx(() => [
                                            _createTextVNode(" " + _toDisplayString(redemption.claimed ? 'Claimed' : 'Pending'), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["color"])
                                      ])
                                    ]))
                                  }), 128))
                                ])
                              ]),
                              _: 1
                            }))
                          : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                              _createVNode(_component_v_icon, {
                                icon: "mdi-history-off",
                                size: "48",
                                color: "grey",
                                class: "mb-2"
                              }),
                              _cache[4] || (_cache[4] = _createElementVNode("div", { class: "text-grey" }, "No redemptions yet", -1)),
                              _createVNode(_component_v_btn, {
                                color: "primary",
                                variant: "text",
                                class: "mt-4",
                                to: "/rewards"
                              }, {
                                default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                                  _createTextVNode(" Browse Rewards Store ", -1)
                                ]))]),
                                _: 1
                              })
                            ]))
                      ]))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}
}

})